import Connection from './Connection';

interface AWSConnectionArgs {
  awsAccessKeyId?: string;
  awsSecretAccessKey?: string;
  apigwConnectionId?: string;
}

class AWSConnection extends Connection {
  constructor(connectionArgs: AWSConnectionArgs) {
    super("aws", connectionArgs);
  }

  static fromJson(json: any): AWSConnection {
    return new AWSConnection(
      json.connection_args || json.connectionArgs || {}
    );
  }
}

export default AWSConnection;